import React, { Component } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { Plus } from 'lucide-react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './AppointmentCalendar.css';

moment.locale('tr');
const localizer = momentLocalizer(moment);

const calendarMessages = {
    allDay: 'Tüm Gün',
    previous: 'Önceki',
    next: 'Sonraki',
    today: 'Bugün',
    month: 'Ay',
    week: 'Hafta',
    day: 'Gün',
    agenda: 'Ajanda',
    date: 'Tarih',
    time: 'Saat',
    event: 'Olay',
    noEventsInRange: 'Bu aralıkta randevu yok.',
    showMore: total => `+${total} daha göster`,
};

class AppointmentCalendar extends Component {
    render() {
        const { appointments, onSelectSlot, onSelectEvent, onNewAppointmentClick, hasPermission } = this.props;

        return (
            <div className="appointment-container">
                <div className="list-header">
                    <h1>Appointment Calendar</h1>
                    <button className="add-button" onClick={onNewAppointmentClick} disabled={!hasPermission('manageAppointments')}>
                        <Plus size={18} /> New Appointment
                    </button>
                </div>
                <div className="calendar-wrapper">
                    <BigCalendar
                        localizer={localizer}
                        events={appointments}
                        startAccessor="start"
                        endAccessor="end"
                        selectable
                        onSelectSlot={onSelectSlot}
                        onSelectEvent={onSelectEvent}
                        messages={calendarMessages}
                        views={['month', 'week', 'day', 'agenda']}
                        defaultView="month"
                        popup
                        step={30}
                        showMultiDayTimes
                    />
                </div>
            </div>
        );
    }
}

export default AppointmentCalendar;
